const tracks = {
  ERROR_FILE_MAX_SIZE:
    'up_documento: viu_erro arquivo_maior_que30mb [tela_up_documentos]',
  ERROR_QTD_MAX_FILES:
    'up_documento: viu_erro qtd_de_arquivos_maior [tela_up_documentos]',
  ERROR_NOT_ATTACH_DOCS:
    'up_documento: viu_erro alerta_doc_nao_subiu [tela_up_documentos]',
}

export { tracks }
